export default __webpack_public_path__ + "static/media/menu-down-icon.bc0b9b15.svg";